'use strict';

var angularModule = angular.module('t2g.common.data-access.resource', []);

module.exports = angularModule;

angularModule.factory('ResourceResource', function($resource, settings) {
  var resourceUrl = settings.apiBase + '/api/v2/resource/:resourceId';

  var resource = $resource(
    resourceUrl,
    {},
    {
      insert: { method: 'post' },
      remove: { method: 'delete' },
      list: { method: 'get' },
      get: { method: 'get' },
      update: { method: 'put', params: { resourceId: '@_id' } },
      refreshCalendarAddress: { method: 'post', params: { resourceId: 'refreshCalendarAddress' } },
    },
  );

  return resource;
});

angularModule.factory('ResourceDA', function($q, ResourceResource) {
  var resourceCache = [];

  return {
    clearCache: clearCache,
    get: get,
    insert: insert,
    list: list,
    remove: remove,
    update: update,
    refreshCalendarAddress: refreshCalendarAddress,
  };

  function refreshCalendarAddress(resourceId) {
    return ResourceResource.refreshCalendarAddress({ resourceId: resourceId }).$promise.then(
      function(response) {
        _.remove(resourceCache, { _id: resourceId });
        resourceCache.push(response.resource);
        return response.resource;
      },
    );
  }

  function clearCache() {
    resourceCache = [];
  }

  function get(resourceId) {
    return ResourceResource.get({ resourceId: resourceId }).$promise;
  }

  function insert(resource) {
    return ResourceResource.insert(resource).$promise.then(function(response) {
      resourceCache.push(response.resource);
      return response.resource;
    });
  }

  function list(type) {
    var filter = {};

    if (type) {
      filter.type = type;
    }

    if (resourceCache.length > 0) {
      return $q.when({
        resources: _.filter(resourceCache, filter),
      });
    } else {
      return ResourceResource.list().$promise.then(function(response) {
        resourceCache = response.resources;
        return {
          resources: _.filter(response.resources, filter),
        };
      });
    }
  }

  function remove(resourceId) {
    return ResourceResource.remove({ resourceId: resourceId }).$promise.then(function() {
      _.remove(resourceCache, { _id: resourceId });
      return true;
    });
  }

  function update(resource) {
    return ResourceResource.update(resource).$promise;
  }
});



// WEBPACK FOOTER //
// ./src/app/common/data-access/resource.js